// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quill-editor-container {
  width: 100%;
  margin: 0 auto;
}

.quill-editor-container .ql-container {
  min-height: 200px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: #fff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  font-size: 14px;
  line-height: 1.5;
}

.quill-editor-container .ql-toolbar {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background-color: #f8f9fa;
  border: 1px solid #ced4da;
  border-bottom: none;
  padding: 8px;
}

.quill-editor-container .ql-editor {
  min-height: 200px;
  font-size: 16px;
  line-height: 1.5;
  padding: 12px 15px;
}

.quill-editor-container .ql-editor:focus {
  outline: none;
}

.quill-editor-container .ql-toolbar button {
  margin: 0 4px;
  padding: 4px 8px;
  border-radius: 2px;
}

.quill-editor-container .ql-toolbar button:hover {
  background-color: #e6f4ff;
}

.quill-editor-container .ql-toolbar .ql-active {
  background-color: #e6f4ff;
  color: #1890ff;
}

.quill-editor-container .ql-formats {
  margin-right: 12px;
}

.quill-editor-container .ql-container {
  border: 1px solid #d9d9d9;
}

.quill-editor-container .ql-editor.ql-blank::before {
  color: #bfbfbf;
  font-style: normal;
}

/* Custom styles for toolbar dropdowns */
.quill-editor-container .ql-picker {
  height: 24px;
}

.quill-editor-container .ql-picker-label {
  padding: 2px 4px;
  border: 1px solid transparent;
}

.quill-editor-container .ql-picker-label:hover {
  border-color: #d9d9d9;
}

.quill-editor-container .ql-picker-options {
  background: #fff;
  border: 1px solid #d9d9d9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 4px 0;
}

.quill-editor-container .ql-picker-item {
  padding: 4px 8px;
}

.quill-editor-container .ql-picker-item:hover {
  background-color: #e6f4ff;
  color: #1890ff;
}

.quill-editor-wrapper {
  background-color: white;
  border-radius: 4px;
  overflow: visible;
  position: relative;
}

.custom-quill {
  background-color: white;
}

.custom-quill .ql-container {
  min-height: 200px;
  background-color: white;
  border: 1px solid #ccc;
  border-top: 0;
}

.custom-quill .ql-toolbar {
  background-color: white;
  border: 1px solid #ccc;
}

.custom-quill .ql-editor {
  min-height: 200px;
  background-color: white;
  color: #333;
}

/* Override any inherited background colors */
.custom-quill .ql-editor p,
.custom-quill .ql-editor span,
.custom-quill .ql-editor div {
  background-color: white;
}

/* Ensure toolbar buttons are visible */
.custom-quill .ql-toolbar button,
.custom-quill .ql-toolbar .ql-picker {
  color: #333;
}

.custom-quill .ql-toolbar button:hover,
.custom-quill .ql-toolbar button:focus {
  color: #000;
}

/* Make sure the placeholder text is visible */
.custom-quill .ql-editor.ql-blank::before {
  color: #666;
}

/* Emoji picker styles - ensure it's visible and properly positioned */
#emoji-palette {
  z-index: 10000 !important;
  position: absolute !important;
}

#textarea-emoji {
  z-index: 10000 !important;
  position: absolute !important;
}

.emoji_completions {
  z-index: 10000 !important;
  position: absolute !important;
}

#emoji-close-div {
  z-index: 9999 !important;
} 

.ql-formats {
  margin-right: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Editor/editor.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,2FAA2F;EAC3F,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA,6CAA6C;AAC7C;;;EAGE,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,WAAW;AACb;;AAEA,sEAAsE;AACtE;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".quill-editor-container {\n  width: 100%;\n  margin: 0 auto;\n}\n\n.quill-editor-container .ql-container {\n  min-height: 200px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background: #fff;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.quill-editor-container .ql-toolbar {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  background-color: #f8f9fa;\n  border: 1px solid #ced4da;\n  border-bottom: none;\n  padding: 8px;\n}\n\n.quill-editor-container .ql-editor {\n  min-height: 200px;\n  font-size: 16px;\n  line-height: 1.5;\n  padding: 12px 15px;\n}\n\n.quill-editor-container .ql-editor:focus {\n  outline: none;\n}\n\n.quill-editor-container .ql-toolbar button {\n  margin: 0 4px;\n  padding: 4px 8px;\n  border-radius: 2px;\n}\n\n.quill-editor-container .ql-toolbar button:hover {\n  background-color: #e6f4ff;\n}\n\n.quill-editor-container .ql-toolbar .ql-active {\n  background-color: #e6f4ff;\n  color: #1890ff;\n}\n\n.quill-editor-container .ql-formats {\n  margin-right: 12px;\n}\n\n.quill-editor-container .ql-container {\n  border: 1px solid #d9d9d9;\n}\n\n.quill-editor-container .ql-editor.ql-blank::before {\n  color: #bfbfbf;\n  font-style: normal;\n}\n\n/* Custom styles for toolbar dropdowns */\n.quill-editor-container .ql-picker {\n  height: 24px;\n}\n\n.quill-editor-container .ql-picker-label {\n  padding: 2px 4px;\n  border: 1px solid transparent;\n}\n\n.quill-editor-container .ql-picker-label:hover {\n  border-color: #d9d9d9;\n}\n\n.quill-editor-container .ql-picker-options {\n  background: #fff;\n  border: 1px solid #d9d9d9;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  padding: 4px 0;\n}\n\n.quill-editor-container .ql-picker-item {\n  padding: 4px 8px;\n}\n\n.quill-editor-container .ql-picker-item:hover {\n  background-color: #e6f4ff;\n  color: #1890ff;\n}\n\n.quill-editor-wrapper {\n  background-color: white;\n  border-radius: 4px;\n  overflow: visible;\n  position: relative;\n}\n\n.custom-quill {\n  background-color: white;\n}\n\n.custom-quill .ql-container {\n  min-height: 200px;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-top: 0;\n}\n\n.custom-quill .ql-toolbar {\n  background-color: white;\n  border: 1px solid #ccc;\n}\n\n.custom-quill .ql-editor {\n  min-height: 200px;\n  background-color: white;\n  color: #333;\n}\n\n/* Override any inherited background colors */\n.custom-quill .ql-editor p,\n.custom-quill .ql-editor span,\n.custom-quill .ql-editor div {\n  background-color: white;\n}\n\n/* Ensure toolbar buttons are visible */\n.custom-quill .ql-toolbar button,\n.custom-quill .ql-toolbar .ql-picker {\n  color: #333;\n}\n\n.custom-quill .ql-toolbar button:hover,\n.custom-quill .ql-toolbar button:focus {\n  color: #000;\n}\n\n/* Make sure the placeholder text is visible */\n.custom-quill .ql-editor.ql-blank::before {\n  color: #666;\n}\n\n/* Emoji picker styles - ensure it's visible and properly positioned */\n#emoji-palette {\n  z-index: 10000 !important;\n  position: absolute !important;\n}\n\n#textarea-emoji {\n  z-index: 10000 !important;\n  position: absolute !important;\n}\n\n.emoji_completions {\n  z-index: 10000 !important;\n  position: absolute !important;\n}\n\n#emoji-close-div {\n  z-index: 9999 !important;\n} \n\n.ql-formats {\n  margin-right: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
